import { listReport } from './WashingCountByDay/WashingCount.i18n.en'

export const washingCount = {
  listReport,
}
